import { useDispatch } from "react-redux"
import { ModalContent, ModalButtonWrapper, Close } from "./common"
import ModalBase from "./modal-base"
import { ButtonWithImage } from "@components/buttons"
import { setModalSettingsState, modalSettingsObj } from "../../states/slices/modal-settings"

const ModalOverlay = ({ buttonList, buttonWrapperColor = "yellow", children, ...props }) => {
  const dispatch = useDispatch()

  const wrapOnClick = (onClick, label) => async (...args) => {
    const result = onClick?.(...args)
    if (result instanceof Promise) {
      const loadingKey = `modal-overlay/${label}`
      dispatch(setModalSettingsState({ type: modalSettingsObj.isLoadingOpen, value: loadingKey }))
      try {
        await result
      } finally {
        dispatch(setModalSettingsState({ type: modalSettingsObj.isLoadingOpen, value: loadingKey }))
      }
    }
  }

  return (
    <ModalBase {...props}>
      <ModalContent expand maxwidth="720px">
        <Close onClick={props.onClose} />
        {children && children}
        <ModalButtonWrapper color={buttonWrapperColor}>
          {buttonList?.map(({ textcolor = "brown_1", width = "115px", onClick, ...btnProp }) => (
            <ButtonWithImage
              textcolor={textcolor}
              sx={{ width }}
              key={`modal button ${btnProp.label}`}
              onClick={wrapOnClick(onClick, btnProp.label)}
              {...btnProp}
            />
          ))}
        </ModalButtonWrapper>
      </ModalContent>
    </ModalBase>
  )
}

export default ModalOverlay
